import * as Util from './util.js';

class i18n {
    static t(text, params = {}) {
        if (typeof window.i18nData[text] === 'string' && '' !== window.i18nData[text]) {
            let template = window.i18nData[text];

            return Util.template(template, params);
        }
        return text;
    }

}

export {i18n};
